export const apiUrl = 'https://d1nx86j0adclnv.cloudfront.net';
